import { render, staticRenderFns } from "./stock-detail.vue?vue&type=template&id=c6571de8&scoped=true&"
import script from "./stock-detail.vue?vue&type=script&lang=js&"
export * from "./stock-detail.vue?vue&type=script&lang=js&"
import style0 from "./stock-detail.styl?vue&type=style&index=0&id=c6571de8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6571de8",
  null
  
)

export default component.exports